export { default as GhEditor } from "./GhEditor.vue"
export { default } from "./GhEditor.vue"
